import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { colors } from "style";

/**
 * SquadIcon
 *
 * @param {String}    name
 * @param {String}    organizationName
 * @param {String}    size
 */
const SquadIcon = ({ name, organizationName, size, ...props }) => (
  <Icon {...props} color={getColor(organizationName)} size={size}>
    {name
      .replace(/[^\p{L}\s]/gu, "") // Remove special characters
      .split(" ")
      .slice(0, 2)
      .map((item) => item[0])
      .join("")
      .toUpperCase()}
  </Icon>
);

const Icon = styled.div`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  background: ${({ color }) => color};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  font-size: ${({ size }) => `calc(${size} / 3)`};
`;

function getColor(name) {
  const firstChar = name?.charAt(0);

  if (!firstChar) {
    return colors.purpleRainBase;
  }

  if (firstChar.match(/[a-d]/i)) {
    return colors.pinkPantherBase;
  } else if (firstChar.match(/[e-h]/i)) {
    return colors.orangeCountyBase;
  } else if (firstChar.match(/[i-l]/i)) {
    return colors.blueVelvetBase;
  } else if (firstChar.match(/[m-p]/i)) {
    return colors.green;
  } else {
    return colors.purpleRainBase;
  }
}

SquadIcon.propTypes = {
  name: PropTypes.string,
  organizationName: PropTypes.string,
  size: PropTypes.string,
};

SquadIcon.defaultProps = {
  size: "3rem",
};

export default SquadIcon;
